import React from 'react';

import css from './Hero.module.css';

const Hero = () => {
  return (
    <header className={css.heroContainer}>
      <div className={css.hero}>
        <div className={css.description}>
          <h1 className={css.heading}>RV &amp; Motorhome Rentals</h1>
        </div>
        <div className={css.imageContainer}>
          <div
            className="float-right w-full h-full bg-right bg-no-repeat bg-cover img"
            style={{
              backgroundImage: `url('https://dsqeev865ph38.cloudfront.net/media/images/20190414-outdoorsy-d-06853x_t7.width-1920.jpegquality-90_OkxR4aP.jpg')`,
            }}
          />
        </div>
      </div>
    </header>
  );
};

export default Hero;
